import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { getSlaContractStatusColor } from '@/app/landing/sla/shared/utils/sla-status.utils';
import { SlaTypeDot } from '@/app/landing/sla/shared/components/SlaTypeDot';

type Props = {
  status: string;
};

export function SlaStatusTag({ status }: Props) {
  const { t } = useTranslation('sla');
  const color = getSlaContractStatusColor(status);

  return (
    <Flex align="center" gap={8}>
      <SlaTypeDot color={color} size={10} />
      <Typography.Text style={{ fontWeight: 600, fontSize: '0.8125rem' }}>
        {t(`status.${status}`, status)}
      </Typography.Text>
    </Flex>
  );
}
